import { render } from "./AgencyUsers.vue?vue&type=template&id=ba56c9c2&scoped=true&ts=true"
import script from "./AgencyUsers.vue?vue&type=script&lang=ts"
export * from "./AgencyUsers.vue?vue&type=script&lang=ts"

import "./AgencyUsers.vue?vue&type=style&index=0&id=ba56c9c2&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba56c9c2"]])

export default __exports__